import React from "react";

import styles from "./TextAreaField.module.scss";
import HelpHoverIcon from "components/HelpHoverIcon";

interface TextAreaFieldProps {
  label: string;
  value: string;
  setValue: (val: string) => void;
  helpMessage?: string;
  minLength?: number;
  maxLength?: number;
  error?: boolean;
}

const TextAreaField = ({
  label,
  value,
  setValue,
  helpMessage,
  minLength,
  maxLength,
  error = false,
}: TextAreaFieldProps) => {
  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const text = e.target.value;

    if (maxLength === undefined || text.length > maxLength) {
      return;
    }

    setValue(text);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <label className={styles.label}>{label}</label>
        {helpMessage && <HelpHoverIcon message={helpMessage} />}
      </div>
      <textarea
        className={`${styles.textarea} ${error && styles.textareaError}`}
        value={value}
        onChange={onChange}
      />
      {(minLength || maxLength) && (
        <div className={styles.remainingText}>
          {minLength && <span>min. {minLength} characters</span>}
          {minLength && maxLength && <span>,&nbsp;</span>}
          {maxLength && (
            <span>remaining {maxLength - value.length} characters</span>
          )}
        </div>
      )}
    </div>
  );
};

export default TextAreaField;
